import _     from 'lodash';
import axios from 'axios';
import { requestStarted, requestEnded, addPopup } from '../redux/actions';
import * as popups from '../constants/popup-types';

import AppConfig from '../app/config/AppConfig';

export default class baseRequest {
    constructor() {
        this.Config = new AppConfig();
    }

    call(methodName, params = {}, method = 'post') {
        let requestUrl = this.buildMethodUrl(methodName);
        let data       = new FormData();
        let settings   = {};
        //build form data
        if(_.isEmpty(params)===false) {
            for(let key in params) {
                data.append(key, params[key]);
            }
        } else {
            data = null;
        }

        if(this.Config.debug_mode) {
            console.log('%cmaking request:' + requestUrl, 'color: #0000FF', '');
            console.log('%c---request payload:', 'color: #0000FF',  params);
        }



        settings.method = method;
        settings.url    = requestUrl;
        settings.withCredentials = true;
        method === 'post' ? settings.data = data : settings.params = params;

        this.dispatch(requestStarted());
        axios(settings).then((response) => {
            this.response = response.data;
            let apiResponse = response.data;
            if(apiResponse.status) {
                this.parseResponse(apiResponse);
            } else {
                this.onFailure(apiResponse, methodName);
            }
            this.dispatch(requestEnded());
        }).catch((error) => {
            this.dispatch(requestEnded());
            console.log('catch error:', error);
            this.handleServerError(error);
        });
    }

    //check api response status
    parseResponse(response) {
        response.status === 1 ? this.onSuccess(response) : this.onFailure(response);
    }

    //Generic success method. Override in child class for custom behaviour.
    onSuccess() {
        console.log(this.name, ' successful');
    }

    //Generic failure method. Override in child class for custom behaviour.
    onFailure(response, methodName = '') {
        this.dispatch(addPopup({
            type:popups.GENERAL_MESSAGE,
            text: 'תקלת שרת, אנא נסה שנית מאוחר יותר',
            popup_id: Math.round(Math.random() * 1000000)
        }));
        console.log('%c---request failed:' + this.name, 'color: #FF0000');
    }

    //request utility functions
    buildBaseUrl() {
        return (this.Config.api.https ? 'https' :'http') +
            '://'+ this.Config.api.baseUrl +
            '/' + this.Config.api.path +
            '/' + this.Config.api.platform +
            '/' + this.Config.api.version + '/';
    }

    buildMethodUrl(methodName) {
        return this.buildBaseUrl() + methodName;
    }

    mergeRequestSettings(settings) {
        let requestSettings = '';

        for (let key in settings) {
            if (key in settings) {
                requestSettings[key] = settings[key];
            }
        }

        return requestSettings;
    }
    handleServerError(error) {
        this.dispatch(addPopup({type:popups.API_MESSAGE, text:error.message}));
    }
}